import React from 'react';
import Select from '../Select';

const SelectYesNo = (props) => <Select {...props} optionValues={['Yes', 'No']} />;

export default SelectYesNo;
